export default {
    clients: 'clients',
    search_clients: 'Search',
    choosen_client: 'Chosen client',
    add_client: 'Client data',
    add_new_client: 'Add client',
    invitation_link: 'Invitation link',
    info: '*Before creating a client, check the entered data. If you enter an email, the client will receive an invitation to complete the registration via email (recommended). If there is no e-mail, the invitation will be sent by SMS because the phone number is mandatory. The client can later change his data, while you enter only the initial data. If the email already exists in our system, the data will be filled in automatically.*',
    number_of_clients:
        'Your company currently has <b>{number} clients</b> on the <b>bookeraj</b> platform - a place where all your important contacts are always at your fingertips. 🚀',
    first_and_last_name: 'First and last name',
    email: 'Email',
    phone_number: 'Phone number',
    active: 'Active',
    records: 'Notes',
    history: 'History',
    client_reservations: 'Reservations from client: {client}',
    no_client_found: 'Client not selected!',
    client_not_selected:
        'The client has not been selected, so their entry will not be saved. Do you want to continue and confirm the reservation?',
}
